import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Banner, Sponsors, ProjectSection } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Banner />
        <ProjectSection />
        <Testimonials />
        <Team />
        <Sponsors />

      </section>

    </>
  );
}

export default AboutUs;